window.addEventListener("DOMContentLoaded", function () {
  const slider = new Splide(".gallery-lightbox-container .image-slider", {
    type: "loop",
    drag: "free",
    focus: "center",
    perPage: 3,
    autoWidth: true,
    gap: 20,
    autoScroll: {
      speed: 0.15,
    },
    pagination: true,
    arrows: true,
    classes: {
      pagination: "splide__pagination",
      arrows: "splide__arrows gallery-lightbox-arrows",
      arrow: "splide__arrow gallery-lightbox-arrow",
      prev: "splide__arrow--prev gallery-lightbox-arrow-prev",
      next: "splide__arrow--next gallery-lightbox-arrow-next",
    },
  }).mount(window.splide.Extensions);
});

function openImageLightbox(index) {
  const images = Array.from(
    document.querySelectorAll(".image-slider-item img")
  );
  const selectedImage = images[index];
  const lightbox = document.getElementById("image-lightbox");
  const imgEl = document.getElementById("lightbox-img");
  imgEl.src = selectedImage.src;
  lightbox.classList.add("active");
  document.body.style.overflow = "hidden";
}

function closeImageLightbox() {
  const lightbox = document.getElementById("image-lightbox");
  lightbox.classList.remove("active");
  document.body.style.overflow = "";
}

function openMasonryLightbox() {
  const lightbox = document.getElementById("masonry-lightbox");
  lightbox.classList.add("active");
  document.body.style.overflow = "hidden";
}

function closeMasonryLightbox() {
  const lightbox = document.getElementById("masonry-lightbox");
  lightbox.classList.remove("active");
  document.body.style.overflow = "";
}
document.addEventListener("click", function (event) {
  const imageLightbox = document.getElementById("image-lightbox");
  const masonryLightbox = document.getElementById("masonry-lightbox");
  const isImageLightboxActive = imageLightbox.classList.contains("active");
  const isMasonryLightboxActive = masonryLightbox.classList.contains("active");
  const isImageLightbox = event.target.classList.contains("image-lightbox");
  const isMasonryLightbox = event.target.classList.contains("masonry-lightbox");
  const shouldCloseImageLightbox = isImageLightboxActive && isImageLightbox;
  const shouldCloseMasonryLightbox =
    isMasonryLightboxActive && isMasonryLightbox;

  if (shouldCloseImageLightbox) {
    closeImageLightbox();
  }

  if (shouldCloseMasonryLightbox) {
    closeMasonryLightbox();
  }
});
